import React, { useRef } from "react";
import { TimePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "./BMXTimePicker.scss";

const BMXTimePicker = (props) => {
  const {
    noSetTime,
    input,
    meta: { error, submitError, touched },
    ...rest
  } = props;

  const isError = () => Boolean((touched && error) || submitError);

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const ref = useRef();

  let defaultTime = null;

  if (!noSetTime) {
    // Domyślna wartość 00:00
    const defaultTime = new Date();
    defaultTime.setHours(0, 0, 0, 0);
  }

  // Obsłuż brak wartości
  const value = input.value ? new Date(input.value) : defaultTime;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        ref={ref}
        ampm={false}
        value={value}
        onChange={(newValue) => input.onChange(newValue)}
        {...rest}
        renderInput={(params) => (
          <TextField
            {...params}
            onKeyDown={onKeyDown}
            onClick={() => {
              ref.current
                ?.querySelector('[aria-label*="Choose time"]')
                ?.click();
            }}
            className="BMXTimePicker"
            type="date"
            id="standard-basic"
            variant="standard"
            error={isError()}
            helperText={isError() ? error || submitError : ""}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default BMXTimePicker;
